import React from 'react';
import { History } from 'history';
import { Input, InputColor, InputMultiline, InputDate, InputFile, InputSwitch, InputPicklist, InputSelect, ThemeFont } from '../../components';
import BaseCopy from '../base/base-copy.component'; 
import Model from './app-model';  //editable..
import MedialibraryModel from '../medialibrary/medialibrary-model';
import OwnerPicklist from '../owner/owner-picklist.component';
import AppService from '../../services/app.service';

interface IProps { 
    history: History;
}

interface IState {
    datarow: Model;
    errors: any;
    datarowMedia: any;
}

export default class AppCopy extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {
            datarow: Model.defaultValue(),
            errors: null,
            datarowMedia: null,
        }
        this.onChange = this.onChange.bind(this);
    }

    private onLoad = (data: any) => {
        this.setState({datarow:  data});
    }
    
    private onLoadOwner = (data: any) => {
        this.setState({ datarow: { ...this.state.datarow, 'owner': data?.id, 'ownerCaption': data?.name || ''  }  });
    }

    private onLoadFile = (data: any) => {
        this.setState({datarowMedia: {...this.state.datarowMedia, endPoint: MedialibraryModel.endPoint, endPointDelete: MedialibraryModel.endPoint2, datarow:{id:this.state.datarow.imageId, files: data, ref: Model.endPointMedia, field:'image'}}});
    }
    
    private onError = (data: any) => {
        this.setState({errors: data});
    }
    
    private onChange(fieldName: string, value?: string) { 
        const nextState = {
            ...this.state, datarow: {
                ...this.state.datarow, [fieldName]: value,
            }
        }
        this.setState(nextState);
    }

    render() {
        return (
            //editable..
            <BaseCopy history={this.props.history} 
                model={Model} datarow={this.state.datarow} datarowMedia={this.state.datarowMedia} onLoad={this.onLoad} onError={this.onError}>              
                
                <InputSwitch name='status' label='Status' value={this.state.datarow.status} options={Model.optionStatus} error={this.state.errors?.status} onChange={this.onChange}/>
                <Input name='name' label='Name' value={this.state.datarow.name} error={this.state.errors?.name} onChange={this.onChange} />
                <InputMultiline name='description' label='Description' value={this.state.datarow.description} error={this.state.errors?.description} onChange={this.onChange} />
                {AppService.isAppFullVersion() &&
                <InputPicklist name='owner' label='Owner' value={this.state.datarow.owner} caption={this.state.datarow.ownerCaption} error={this.state.errors?.owner} onChange={this.onChange} >
                    <OwnerPicklist currentId={this.state.datarow.owner} onLoad={this.onLoadOwner}/>
                </InputPicklist>
                } 
                <InputDate name='expireddate' label='Expired Date' value={this.state.datarow.expireddate} error={this.state.errors?.expireddate} onChange={this.onChange} />
                <InputColor name='theme.color.primary' label='Primary Color' value={this.state.datarow.theme?.color?.primary} error={this.state.errors?.theme?.color?.primary} onChange={this.onChange} />
                <InputColor name='theme.color.secondary' label='Secondary Color' value={this.state.datarow.theme?.color?.secondary} error={this.state.errors?.theme?.color?.secondary} onChange={this.onChange} />
                <InputColor name='theme.color.info' label='Info Color' value={this.state.datarow.theme?.color?.info} error={this.state.errors?.theme?.color?.info} onChange={this.onChange} />
                <InputColor name='theme.color.success' label='Success Color' value={this.state.datarow.theme?.color?.success} error={this.state.errors?.theme?.color?.success} onChange={this.onChange} />
                <InputColor name='theme.color.warning' label='Warning Color' value={this.state.datarow.theme?.color?.warning} error={this.state.errors?.theme?.color?.warning} onChange={this.onChange} />
                <InputColor name='theme.color.error' label='Error Color' value={this.state.datarow.theme?.color?.error} error={this.state.errors?.theme?.color?.error} onChange={this.onChange} />
                <InputSelect name='theme.font' label='Font' value={this.state.datarow.theme?.font} options={ThemeFont} error={this.state.errors?.theme?.font} onChange={this.onChange} />
                <InputFile name='imageUrl' label='Logo' value={this.state.datarow.imageUrl} type='image' onLoad={this.onLoadFile} error={this.state.errors?.image} onChange={this.onChange} />
                          

            </BaseCopy>
        );
    }
}